export const appEndpoint = {
  getUser: `/getUser`,
  logout: '/logout',
  getProjects:'/projects',
  createProject:'/projects',
  updateProject:'/projects',
  deleteProject:'/projects',
  getUsers:'/users',
  addUser:'/users',
  updateUser:'/users',
  deleteUser: '/users',
  getBlogs:'/blogs',
  addBlog:'/blogs',
  updateBlog:'/blogs',
  deleteBlog: '/blogs',
  teamProfiles:'/team_profiles',
  units:'/units',
  subscribers:'/subscribers',
  scheduledVisit:'/scheduled_visit',
  changePassword:'/change-password',
  testimonials:'/testimonials',
  partners:'/partners',
  unitTypes:'/unit_types',
  bankAccounts: '/bank_accounts',
  dashboardSummary:'/dashboard/summary',
  contactMessages: '/contact_messages',
  newsLetters:'/newsletter',
  sendNewsletter:'/newsletter/send',
  legalDocuments:'/legal_documents'
};